import React, {
  useEffect,
  useState,
  useCallback,
  useMemo,
  useRef,
} from "react";
import axios from "axios";
import { Helmet } from "react-helmet";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { toast } from "react-toastify";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import Footer from "./Footer";
import debounce from "lodash/debounce";
import Header from "./Header";
import { useSwipeable } from "react-swipeable";
import { motion, AnimatePresence } from "framer-motion";

function ProductDetail() {
  const { procode } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname, search } = location;
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  let { product_id } = useParams();
  let { product_name } = useParams();
  const lastAddedProductRef = useRef(null);
  const [showMoreDetails, setShowMoreDetails] = useState(false);
  const transformRef = useRef(null);
  const dealer_id = localStorage.getItem("dealer_id");
  const dealerId = dealer_id;
  const orderCount = localStorage.getItem("dealer_price_set");
  const server_url = localStorage.getItem("server_url");
  const LoginNumber = localStorage.getItem("LoginNumber");
  const [productDetails, setProductDetails] = useState([]);
  const [swipeDirection, setSwipeDirection] = useState(null);
  const [selectedMedia, setSelectedMedia] = useState(null);
  // State variables for comments
  const [comments, setComments] = useState([]);
  const [showCommentModal, setShowCommentModal] = useState(false);
  const [commentText, setCommentText] = useState("");
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [commentToDelete, setCommentToDelete] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [rotation, setRotation] = useState(0);
  const [scale, setScale] = useState(1);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedMediaIndex, setSelectedMediaIndex] = useState(null);
  const [qrValue, setQrValue] = useState(procode || "");
  const [searchTerm, setSearchTerm] = useState("");
  const [batches, setBatches] = useState({});
  const [displayBatches, setDisplayBatches] = useState([]);
  const [loadedPages, setLoadedPages] = useState(new Set());
  const [allPageKeys, setAllPageKeys] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [addingProducts, setAddingProducts] = useState(new Map());
  const [cartCount, setCartCount] = useState(0);
  const [cartTotal, setCartTotal] = useState(0);
  const productRefs = useRef({});
  const searchInputRef = useRef(null);
  const [isDetailLoading, setIsDetailLoading] = useState(true);
  const [showSteppers, setShowSteppers] = useState(new Map());
  const [quantityInputs, setQuantityInputs] = useState({});
  const hasScrolled = useRef(false);
  const [showSearch, setShowSearch] = useState(false);
  const observer = useRef();
  const [allProducts, setAllProducts] = useState([]); // Store all products for search
  const [productQuantities, setProductQuantities] = useState({});
  const [productStepperStates, setProductStepperStates] = useState({});
  const loginId = dealerId;

  // Theme colors
  const accentColor = "rgb(219, 68, 55)";
  const backgroundColor = "#ffffff";
  const textColor = "#000000";
  const textSecondary = "#666666";
  const borderColor = "#e0e0e0";
  const cardShadow = "0 2px 8px rgba(0, 0, 0, 0.08)";
  const hoverShadow = "0 4px 12px rgba(0, 0, 0, 0.12)";

  // Fetch comments for product
  const fetchComments = async (productId) => {
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("dealer_id", dealerId || "");
      formData.append("promotion_id", "");
      formData.append("product_id", productId);
      const res = await axios.post(
        `${server_url}promotion_comment_list.php`,
        formData,
      );
      if (res.data.status === "1") {
        setComments(res.data.result);
      } else {
        setComments([]);
      }
    } catch (e) {
      toast.error("Failed to load comments.");
    }
  };
  // Dynamic column count
  const getColumnCount = () => {
    const width = window.innerWidth;
    if (width >= 2500) return 7;
    if (width >= 2000) return 6;
    if (width >= 1500) return 5;
    if (width >= 1200) return 4;
    if (width >= 768) return 2;
    return 2;
  };

  const [columnCount, setColumnCount] = useState(getColumnCount());
  // Media change handlers
  const changeMedia = (newIndex, direction) => {
    if (!selectedProduct) return;
    const mediaList = getAllMediaItems(selectedProduct);
    setSelectedMediaIndex(newIndex);
    setSelectedMedia(mediaList[newIndex]);
    setRotation(0);
    setSwipeDirection(direction);
    setScale(1);
    transformRef.current?.resetTransform(0);
  };
  useEffect(() => {
    const handleResize = () => {
      setColumnCount(getColumnCount());
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  // Update URL with search parameters
  const updateURLWithSearch = useCallback((searchValue) => {
    const url = new URL(window.location);
    if (searchValue && searchValue.trim() !== "") {
      url.searchParams.set("search", searchValue.trim());
    } else {
      url.searchParams.delete("search");
    }
    window.history.replaceState({}, "", url.toString());
  }, []);
  // Handle comment deletion
  const handleDeleteComment = async (commentId) => {
    setCommentToDelete(commentId);
    setShowDeleteConfirm(true);
  };
  // Confirm comment deletion
  const confirmDeleteComment = async () => {
    if (!dealerId) {
      const currentPath = location.pathname + location.search;
      localStorage.setItem("login_url", currentPath);
      navigate("/Logout");
      return false;
    }
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("dealer_id", dealerId);
      formData.append("product_id", product_id);
      formData.append("promotion_id", "");
      formData.append("promotion_comment_id", commentToDelete);
      const res = await axios.post(
        `${server_url}remove_promotion_comment.php`,
        formData,
      );
      if (res.data.status === "1") {
        fetchComments(product_id);
        setProductDetails((prev) =>
          prev.map((item) =>
            item.product_id === product_id
              ? {
                  ...item,
                  product_total_comment: Math.max(
                    (parseInt(item.product_total_comment) || 1) - 1,
                    0,
                  ),
                }
              : item,
          ),
        );
      } else {
        toast.warning(res.data.error || "Failed to delete comment");
      }
    } catch (e) {
      toast.error("Failed to delete comment.");
    } finally {
      setShowDeleteConfirm(false);
      setCommentToDelete(null);
    }
  };
  // Auto-open search bar and set search term when URL has search parameter
  useEffect(() => {
    fetchProductDetails();
  }, [product_id]);
  const fetchProductDetails = useCallback(async () => {
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("product_id", product_id);
      formData.append("dealer_id", dealerId || "");
      const res = await axios.post(
        `${server_url}product_details.php`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );
      if (res.data.status === "1") {
        let proname = res.data.result[0].product_design_name;
        // Convert proname to PascalCase (same as product_name format)
        proname = proname
          .trim()
          .split(/\s+/)
          .map(
            (word) =>
              word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
          )
          .join("");
        // Remove all spaces
        if (product_name != proname) {
          navigate("/PageNotFound");
        }
        setProductDetails(res.data.result);
        // Initialize quantities for main product
        const newQuantities = {};
        const newStepperStates = {};
        res.data.result.forEach((item) => {
          newQuantities[item.product_id] = item.product_quantity || 0;
          newStepperStates[item.product_id] = item.product_quantity > 0;
        });
        setProductQuantities((prev) => ({ ...prev, ...newQuantities }));
        setProductStepperStates((prev) => ({ ...prev, ...newStepperStates }));
        // Calculate cart count
        const cartItems = res.data.result.filter(
          (item) => item.product_quantity > 0,
        );
        setCartCount(cartItems.length);
      } else {
        setProductDetails([]);
        toast.warning(res.data.error || "No product details found.");
        navigate("/PageNotFound");
      }
    } catch (e) {
      toast.error("Failed to load product details. Please try again.");
      setProductDetails([]);
    } finally {
      setIsDetailLoading(false);
    }
  }, [product_id, dealerId, server_url, product_name, navigate]);
  const headers = { "/AddProduct": { title: "Product List", backLink: "/" } };
  const currentHeader = Object.entries(headers).find(([path]) =>
    location.pathname.startsWith(path),
  );
  const isValidLocalCart = useCallback((localData) => {
    return (
      Array.isArray(localData) &&
      localData.every(
        (item) =>
          item.product_id &&
          item.product_design_name &&
          item.product_image &&
          item.product_quantity !== undefined &&
          item.product_dealer_price !== undefined &&
          item.series_id !== undefined &&
          item.product_qr_value !== undefined,
      )
    );
  }, []);
  const getLocalCart = useCallback(() => {
    const localCart = localStorage.getItem("local_cart");
    try {
      const parsed = localCart ? JSON.parse(localCart) : [];
      return isValidLocalCart(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }, [isValidLocalCart]);
  const saveLocalCart = useCallback((products) => {
    localStorage.setItem("local_cart", JSON.stringify(products));
  }, []);
  // Fetch ALL paginated chunks once
  const fetchAllProducts = useCallback(async () => {
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("dealer_id", dealer_id || "");
      const res = await axios.post(
        `${server_url}products_with_cart_web.php`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );
      if (res.data.status === "1" && res.data.result) {
        const resultObj = res.data.result;
        const pageKeys = Object.keys(resultObj)
          .filter((k) => !isNaN(Number(k)))
          .sort((a, b) => Number(a) - Number(b));
        setAllPageKeys(pageKeys);
        setBatches(resultObj);
        const firstKey = pageKeys[0];
        const firstBatch = resultObj[firstKey] || [];
        setDisplayBatches([firstBatch]);
        setLoadedPages(new Set([firstKey]));
        // Store all products for search functionality
        const allProductsData = Object.values(resultObj).flat();

        console.log(product_id);
        console.log(product_id);

        setAllProducts(allProductsData);
        saveLocalCart(allProductsData);
        setCartTotal(parseFloat(res.data.totalAmount) || 0);
        const qtyMap = allProductsData.reduce(
          (acc, item) => ({
            ...acc,
            [item.product_id]: item.product_quantity,
          }),
          {},
        );
        setQuantityInputs(qtyMap);
        const steppersMap = new Map();
        allProductsData.forEach((item) => {
          steppersMap.set(item.product_id, item.product_quantity > 0);
        });
        setShowSteppers(steppersMap);
        setCartCount(
          allProductsData.filter((i) => i.product_quantity > 0).length,
        );
      } else {
        setDisplayBatches([]);
        setAllProducts([]);
        toast.warning(res.data.error || "No products");
      }
    } catch (e) {
      toast.error("Failed to load products.");
      setDisplayBatches([]);
      setAllProducts([]);
    } finally {
      setIsLoading(false);
    }
  }, [dealer_id, server_url, saveLocalCart]);
  // Initial load
  useEffect(() => {
    const localData = getLocalCart();
    const currentProductId = product_id;

    if (localData.length > 0 && !procode) {
      const filteredLocalData = localData.filter(
        (item) => item.product_id !== currentProductId,
      );
      if (filteredLocalData.length > 0) {
        const batchSize = 8;
        const batchesFromLocal = {};
        for (let i = 0; i < localData.length; i += batchSize) {
          const page = Math.floor(i / batchSize) + 1;
          batchesFromLocal[page] = localData.slice(i, i + batchSize);
        }
        const keys = Object.keys(batchesFromLocal).sort(
          (a, b) => Number(a) - Number(b),
        );
        setAllPageKeys(keys);
        setBatches(batchesFromLocal);
        const firstKey = keys[0];
        setDisplayBatches([batchesFromLocal[firstKey] || []]);
        setLoadedPages(new Set([firstKey]));
        // Store all products for search
        setAllProducts(localData);
        const qtyMap = localData.reduce(
          (acc, i) => ({ ...acc, [i.product_id]: i.product_quantity }),
          {},
        );
        setQuantityInputs(qtyMap);
        const steppers = new Map();
        localData.forEach((i) =>
          steppers.set(i.product_id, i.product_quantity > 0),
        );
        setShowSteppers(steppers);
        setCartCount(localData.filter((i) => i.product_quantity > 0).length);
        setIsLoading(false);
      }
    } else {
      fetchAllProducts();
    }
  }, [procode, getLocalCart, fetchAllProducts]);

  // Add this function at the top of your component after imports
  const dispatchCartUpdate = (count) => {
    // Dispatch custom event
    const event = new CustomEvent("cart-updated", {
      detail: { cartCount: count },
    });
    window.dispatchEvent(event);

    // Also update localStorage for consistency
    localStorage.setItem("cart_count", count.toString());
  };

  // Load next batch
  const loadNextBatch = useCallback(() => {
    if (isLoadingMore || loadedPages.size >= allPageKeys.length) return;
    const nextIndex = loadedPages.size;
    const nextKey = allPageKeys[nextIndex];
    if (!nextKey || !batches[nextKey]) return;
    setIsLoadingMore(true);
    setTimeout(() => {
      const nextBatch = batches[nextKey];
      setDisplayBatches((prev) => [...prev, nextBatch]);
      setLoadedPages((prev) => new Set(prev).add(nextKey));
      setIsLoadingMore(false);
    }, 300);
  }, [batches, allPageKeys, loadedPages.size, isLoadingMore]);
  // Get all products as a single flat array for display
  const allDisplayProducts = useMemo(() => {
    return displayBatches.flat();
  }, [displayBatches]);
  // Filter products based on search - FIXED PAGINATION ISSUE
  const filteredProducts = useMemo(() => {
    if (!searchTerm) return allDisplayProducts;
    // If we have search term, search through ALL products, not just displayed ones
    return allProducts.filter((p) =>
      p.product_design_name.toLowerCase().includes(searchTerm.toLowerCase()),
    );
  }, [allDisplayProducts, searchTerm, allProducts]);
  // Distribute products column by column (vertically)
  const distributeProductsByColumns = useCallback((products, cols) => {
    if (products.length === 0 || cols === 0) return [];
    const columns = Array.from({ length: cols }, () => []);
    // Distribute products vertically (column by column)
    for (let i = 0; i < products.length; i++) {
      const colIndex = i % cols;
      columns[colIndex].push(products[i]);
    }
    return columns;
  }, []);
  const oddProducts = useMemo(
    () => filteredProducts.filter((p) => parseInt(p.product_id) % 2 === 1),
    [filteredProducts],
  );
  const evenProducts = useMemo(
    () => filteredProducts.filter((p) => parseInt(p.product_id) % 2 === 0),
    [filteredProducts],
  );
  const oddColumns = useMemo(
    () => distributeProductsByColumns(oddProducts, Math.ceil(columnCount / 2)),
    [oddProducts, columnCount, distributeProductsByColumns],
  );
  const evenColumns = useMemo(
    () =>
      distributeProductsByColumns(evenProducts, Math.floor(columnCount / 2)),
    [evenProducts, columnCount, distributeProductsByColumns],
  );
  const productColumns = useMemo(() => {
    return distributeProductsByColumns(filteredProducts, columnCount);
  }, [filteredProducts, columnCount, distributeProductsByColumns]);
  // Observer for infinite scroll - only when not searching
  const lastProductRef = useCallback(
    (node) => {
      if (isLoading || isLoadingMore || searchTerm) return; // Don't load more when searching
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver(
        (entries) => {
          if (
            entries[0].isIntersecting &&
            loadedPages.size < allPageKeys.length
          ) {
            loadNextBatch();
          }
        },
        { rootMargin: "600px" },
      );
      if (node) observer.current.observe(node);
    },
    [
      isLoading,
      isLoadingMore,
      loadedPages.size,
      allPageKeys.length,
      loadNextBatch,
      searchTerm,
    ],
  );
  // Get all media items for a product
  const getAllMediaItems = useCallback((product) => {
    const mediaItems = [];
    // Add product preview images
    if (product.product_preview?.length > 0) {
      product.product_preview.forEach((url, index) => {
        mediaItems.push({
          url,
          type: "image",
          index: mediaItems.length,
        });
      });
    }
    // Add product video
    if (product.product_video) {
      mediaItems.push({
        url: product.product_video,
        type: "video",
        index: mediaItems.length,
      });
    }
    // Add YouTube video
    if (product.product_youtube_video) {
      const embedUrl = getYouTubeEmbedUrl(product.product_youtube_video);
      if (embedUrl) {
        mediaItems.push({
          url: embedUrl,
          type: "youtube",
          index: mediaItems.length,
        });
      }
    }
    return mediaItems;
  }, []);
  const getYouTubeEmbedUrl = (url) => {
    if (!url) return null;
    const standardRegex =
      /(?:youtube.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu.be\/)([^"&?/\s]{11})/;
    const match = url.match(standardRegex);
    return match && match[1]
      ? `https://www.youtube.com/embed/${match[1]}?rel=0&showinfo=0&controls=1&modestbranding=1&enablejsapi=1`
      : null;
  };
  // Handle comment submission
  const handleCommentSubmit = async () => {
    if (!dealerId) {
      const currentPath = location.pathname + location.search;
      localStorage.setItem("login_url", currentPath);
      navigate("/Logout");
      return false;
    }
    if (!commentText.trim()) {
      toast.warning("Comment cannot be empty.");
      return;
    }
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("dealer_id", dealerId);
      formData.append("product_id", product_id);
      formData.append("promotion_id", "");
      formData.append("promotion_comment", commentText);
      const res = await axios.post(
        `${server_url}add_promotion_comment.php`,
        formData,
      );
      if (res.data.status === "1") {
        setCommentText("");
        fetchComments(product_id);
        setProductDetails((prev) =>
          prev.map((item) =>
            item.product_id === product_id
              ? {
                  ...item,
                  product_total_comment:
                    (parseInt(item.product_total_comment) || 0) + 1,
                }
              : item,
          ),
        );
      } else {
        toast.warning(res.data.error || "Failed to add comment");
      }
    } catch (e) {
      toast.error("Failed to add comment.");
    }
  };
  // Memoize media items for current product
  const currentProductMedia = useMemo(() => {
    if (productDetails.length > 0) {
      return getAllMediaItems(productDetails[0]);
    }
    return [];
  }, [productDetails, getAllMediaItems]);
  // Swipe handlers for image slider
  const sliderHandlers = useSwipeable({
    onSwipedLeft: (e) => {
      if (productDetails.length === 0 || e.event.touches?.length > 1) return;
      if (Math.abs(e.velocity) < 0.3) return;
      setSwipeDirection("left");
      setCurrentImageIndex((prevIndex) =>
        prevIndex === currentProductMedia.length - 1 ? 0 : prevIndex + 1,
      );
    },
    onSwipedRight: (e) => {
      if (productDetails.length === 0 || e.event.touches?.length > 1) return;
      if (Math.abs(e.velocity) < 0.3) return;
      setSwipeDirection("right");
      setCurrentImageIndex((prevIndex) =>
        prevIndex === 0 ? currentProductMedia.length - 1 : prevIndex - 1,
      );
    },
    trackMouse: true,
    preventDefaultTouchmoveEvent: false,
    delta: 25,
  });
  // QR & hash scroll
  useEffect(() => {
    if (isLoading || filteredProducts.length === 0) return;
    const matched = filteredProducts.find(
      (item) => item.product_qr_value.toLowerCase() === qrValue.toLowerCase(),
    );
    if (matched && productRefs.current[matched.product_id]) {
      productRefs.current[matched.product_id].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [qrValue, filteredProducts, isLoading]);
  useEffect(() => {
    if (isLoading || filteredProducts.length === 0 || hasScrolled.current)
      return;
    const hash = window.location.hash.replace("#", "");
    if (hash && productRefs.current[hash]) {
      productRefs.current[hash].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      hasScrolled.current = true;
    }
  }, [filteredProducts, isLoading]);
  // Add to cart
  const addToCart = useCallback(
    async (productId, qty) => {
      if (!LoginNumber || LoginNumber.trim() === "" || !dealer_id) {
        const currentPath = location.pathname + location.search;
        localStorage.setItem("login_url", currentPath);
        navigate("/Logout");
        return;
      }
      if (!productId || qty < 0 || isNaN(qty)) return false;
      setAddingProducts((prev) => new Map(prev).set(productId, true));
      try {
        const formData = new FormData();
        formData.append("company_id", "2");
        formData.append("dealer_id", dealer_id || "");
        formData.append("product_id", productId);
        formData.append("qty", qty);
        const res = await axios.post(`${server_url}add_cart.php`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (res.data.status === "1") {
          // Update the specific product in all batches and allProducts
          const updatedBatches = displayBatches.map((batch) =>
            batch.map((item) =>
              item.product_id === productId
                ? { ...item, product_quantity: qty }
                : item,
            ),
          );
          setDisplayBatches(updatedBatches);
          // Also update allProducts for search
          const updatedAllProducts = allProducts.map((item) =>
            item.product_id === productId
              ? { ...item, product_quantity: qty }
              : item,
          );
          setAllProducts(updatedAllProducts);
          saveLocalCart(updatedAllProducts);
          setCartCount(
            updatedAllProducts.filter((i) => i.product_quantity > 0).length,
          );
          setCartTotal(
            updatedAllProducts.reduce(
              (acc, i) => acc + i.product_quantity * i.product_dealer_price,
              0,
            ),
          );

          // Calculate new cart count
          const newCartCount = updatedAllProducts.filter(
            (i) => i.product_quantity > 0,
          ).length;
          setCartCount(newCartCount);

          // Dispatch global cart update event
          dispatchCartUpdate(newCartCount);
          return true;
        } else {
          toast.warning(res.data.error);
          return false;
        }
      } catch (e) {
        toast("Try again later.");
        return false;
      } finally {
        setAddingProducts((prev) => {
          const m = new Map(prev);
          m.delete(productId);
          return m;
        });
      }
    },
    [
      dealer_id,
      server_url,
      displayBatches,
      allProducts,
      saveLocalCart,
      navigate,
    ],
  );
  const debouncedAddToCart = useCallback(debounce(addToCart, 500), [addToCart]);
  const handleQuantityChange = (productId, value) => {
    const qty = value === "" ? "" : parseInt(value, 10);
    setQuantityInputs((prev) => ({ ...prev, [productId]: value }));
    setShowSteppers((prev) => new Map(prev).set(productId, true));
    if (value === "" || (!isNaN(qty) && qty >= 0 && qty <= 99)) {
      if (qty === 0) {
        setShowSteppers((prev) => new Map(prev).set(productId, false));
        debouncedAddToCart(productId, 0);
      } else if (!isNaN(qty)) {
        debouncedAddToCart(productId, qty);
      }
    } else {
      toast("Quantity 0–99 only");
    }
  };
  const handleButtonHold = useCallback(
    (productId, action) => {
      let interval;
      const timeout = setTimeout(() => {
        interval = setInterval(() => {
          setQuantityInputs((prev) => {
            const current = parseInt(prev[productId] || 0, 10);
            const newQty =
              action === "increment"
                ? Math.min(current + 1, 99)
                : Math.max(current - 1, 0);
            setShowSteppers((prevMap) =>
              new Map(prevMap).set(productId, newQty > 0),
            );
            debouncedAddToCart(productId, newQty);
            return { ...prev, [productId]: newQty };
          });
        }, 200);
      }, 500);
      const stop = () => {
        clearTimeout(timeout);
        clearInterval(interval);
        document.removeEventListener("mouseup", stop);
        document.removeEventListener("touchend", stop);
      };
      document.addEventListener("mouseup", stop);
      document.addEventListener("touchend", stop);
    },
    [debouncedAddToCart],
  );
  const handleButtonClick = useCallback(
    (productId, action) => {
      setQuantityInputs((prev) => {
        const current = parseInt(prev[productId] || 0, 10);
        const newQty =
          action === "increment"
            ? Math.min(current + 1, 99)
            : Math.max(current - 1, 0);
        setShowSteppers((prevMap) =>
          new Map(prevMap).set(productId, newQty > 0),
        );

        debouncedAddToCart(productId, newQty);
        return { ...prev, [productId]: newQty };
      });
      setTimeout(() => {
        fetchProductDetails();
      }, 700);
    },
    [debouncedAddToCart],
  );
  const handleAddClick = (productId) => {
    setQuantityInputs((prev) => ({ ...prev, [productId]: 1 }));
    setShowSteppers((prev) => new Map(prev).set(productId, true));
    debouncedAddToCart(productId, 1);
    setTimeout(() => {
      fetchProductDetails();
      // Dispatch cart update
      const newCount = cartCount + 1;
      dispatchCartUpdate(newCount);
    }, 700);
  };
  const handleProductClick = useCallback((productId) => {
    sessionStorage.setItem("last_visited_product", productId);
  }, []);
  const handleSearch = useCallback(
    (value) => {
      setSearchTerm(value);
      setQrValue("");
      updateURLWithSearch(value);
    },
    [updateURLWithSearch],
  );
  // Handle like toggle for product
  const handleLike = async (productId, isLiked) => {
    if (!dealerId) {
      const currentPath = location.pathname + location.search;
      localStorage.setItem("login_url", currentPath);
      navigate("/Logout");
      return false;
    }
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("dealer_id", dealerId);
      formData.append("product_id", productId);
      formData.append("promotion_id", "");
      const endpoint = isLiked
        ? "remove_promotion_like.php"
        : "add_promotion_like.php";
      const res = await axios.post(`${server_url}${endpoint}`, formData);
      if (res.data.status === "1") {
        setProductDetails((prev) =>
          prev.map((item) =>
            item.product_id === productId
              ? {
                  ...item,
                  is_like: isLiked ? "0" : "1",
                  product_total_likes: isLiked
                    ? Math.max((parseInt(item.product_total_likes) || 1) - 1, 0)
                    : (parseInt(item.product_total_likes) || 0) + 1,
                }
              : item,
          ),
        );
      } else {
        toast.warning(res.data.error || "Failed to update like");
      }
    } catch (e) {
      toast.error("Failed to update like status.");
    }
  };
  // Open comment modal
  const openCommentModal = (productId) => {
    setSelectedProductId(productId);
    setShowCommentModal(true);
    fetchComments(productId);
  };
  const handleClearSearch = useCallback(() => {
    setSearchTerm("");
    setQrValue("");
    setShowSearch(false);
    updateURLWithSearch("");
  }, [updateURLWithSearch]);
  const handleSearchIconClick = () => setShowSearch(true);
  // Share functionality for mobile - FIXED
  const handleShare = useCallback(() => {
    const currentUrl = window.location.href;
    // Check if Web Share API is supported
    if (navigator.share) {
      // Use Web Share API for mobile devices
      navigator
        .share({
          title: "Product Search",
          text: `Check out these products${
            searchTerm ? ` matching "${searchTerm}"` : ""
          }`,
          url: currentUrl,
        })
        .then(() => {
          console.log("Successful share");
          toast.success("Shared successfully!");
        })
        .catch((error) => {
          console.log("Error sharing:", error);
          // Fallback to clipboard if share fails
          copyToClipboard(currentUrl);
        });
    } else {
      // Fallback for browsers that don't support Web Share API
      copyToClipboard(currentUrl);
    }
  }, [searchTerm]);
  // Helper function to copy to clipboard
  const copyToClipboard = (text) => {
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          toast.success("URL copied to clipboard!");
        })
        .catch(() => {
          // Fallback for older browsers
          const textArea = document.createElement("textarea");
          textArea.value = text;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand("copy");
          document.body.removeChild(textArea);
          toast.success("URL copied to clipboard!");
        });
    } else {
      // Final fallback
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      toast.success("URL copied to clipboard!");
    }
  };

  // CRITICAL FIX: Load more batches on large screens
useEffect(() => {
  if (isLoading || searchTerm) return;
  
  // On large screens, load more initial batches
  if (window.innerWidth >= 1500 && displayBatches.length === 1 && allPageKeys.length > 1) {
    // Load first 3 batches on large screens
    const batchesToLoad = Math.min(3, allPageKeys.length);
    const newBatches = [];
    
    for (let i = 0; i < batchesToLoad; i++) {
      const key = allPageKeys[i];
      if (batches[key]) {
        newBatches.push(batches[key]);
      }
    }
    
    if (newBatches.length > 1) {
      setDisplayBatches(newBatches);
      setLoadedPages(new Set(allPageKeys.slice(0, batchesToLoad)));
    }
  }
}, [isLoading, displayBatches, allPageKeys, searchTerm, batches]);
  // Auto-focus search input when search is opened
  useEffect(() => {
    if (showSearch && searchInputRef.current) {
      setTimeout(() => {
        searchInputRef.current?.focus();
      }, 100);
    }
  }, [showSearch]);
  // Main product detail render component - FIXED
  const renderProductDetails = (product, isMobile) => {
    const currentQuantity = productQuantities[product.product_id] || 0;
    const showStepper = productStepperStates[product.product_id] || false;
    const isUpdating = addingProducts.has(product.product_id);
    return (
      <React.Fragment key={`product-detail-${product.product_id}`}>
        {!isMobile ? (
          <>
            {/* DESKTOP: Product Images/Media Slider */}
            {currentProductMedia.length > 0 ? (
              <div
                className="media-slider-container-desktop"
                {...sliderHandlers}
              >
                <AnimatePresence mode="wait">
                  {currentProductMedia[currentImageIndex]?.type === "image" && (
                    <motion.img
                      key={`product-image-${product.product_id}-${currentImageIndex}`}
                      src={currentProductMedia[currentImageIndex].url}
                      alt={`Product ${product.product_id} Preview ${currentImageIndex}`}
                      initial={{
                        opacity: 0,
                        x: swipeDirection === "left" ? 100 : -100,
                      }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{
                        opacity: 0,
                        x: swipeDirection === "left" ? -100 : 100,
                      }}
                      transition={{
                        x: {
                          type: "spring",
                          stiffness: 300,
                          damping: 30,
                        },
                        opacity: { duration: 0.2 },
                      }}
                      className="media-slider-image-desktop"
                      onClick={() => {
                        setSelectedMediaIndex(currentImageIndex);
                        setSelectedMedia(
                          currentProductMedia[currentImageIndex],
                        );
                        setSelectedProduct(product);
                        setRotation(0);
                        setScale(1);
                      }}
                    />
                  )}
                  {currentProductMedia[currentImageIndex]?.type === "video" && (
                    <motion.video
                      key={`product-video-${product.product_id}-${currentImageIndex}`}
                      controls
                      initial={{
                        opacity: 0,
                        x: swipeDirection === "left" ? 100 : -100,
                      }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{
                        opacity: 0,
                        x: swipeDirection === "left" ? -100 : 100,
                      }}
                      transition={{
                        x: {
                          type: "spring",
                          stiffness: 300,
                          damping: 30,
                        },
                        opacity: { duration: 0.2 },
                      }}
                      className="media-slider-video-desktop"
                      onClick={() => {
                        setSelectedMediaIndex(currentImageIndex);
                        setSelectedMedia(
                          currentProductMedia[currentImageIndex],
                        );
                        setSelectedProduct(product);
                      }}
                    >
                      <source
                        src={currentProductMedia[currentImageIndex].url}
                        type="video/mp4"
                      />
                      Your browser does not support the video tag.
                    </motion.video>
                  )}
                  {currentProductMedia[currentImageIndex]?.type ===
                    "youtube" && (
                    <motion.div
                      key={`product-youtube-${product.product_id}-${currentImageIndex}`}
                      initial={{
                        opacity: 0,
                        x: swipeDirection === "left" ? 100 : -100,
                      }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{
                        opacity: 0,
                        x: swipeDirection === "left" ? -100 : 100,
                      }}
                      transition={{
                        x: {
                          type: "spring",
                          stiffness: 300,
                          damping: 30,
                        },
                        opacity: { duration: 0.2 },
                      }}
                      className="media-slider-youtube-desktop"
                      onClick={() => {
                        setSelectedMediaIndex(currentImageIndex);
                        setSelectedMedia(
                          currentProductMedia[currentImageIndex],
                        );
                        setSelectedProduct(product);
                      }}
                    >
                      <iframe
                        src={currentProductMedia[currentImageIndex].url}
                        title="YouTube Video"
                        frameBorder="0"
                        allow="autoplay; encrypted-media"
                        className="youtube-iframe-desktop"
                      ></iframe>
                    </motion.div>
                  )}
                </AnimatePresence>
                {/* Media Navigation */}
                {currentProductMedia.length > 1 && (
                  <>
                    <button
                      className="media-nav-btn-desktop media-prev-btn-desktop"
                      onClick={() => {
                        setSwipeDirection("right");
                        setCurrentImageIndex((prevIndex) =>
                          prevIndex === 0
                            ? currentProductMedia.length - 1
                            : prevIndex - 1,
                        );
                      }}
                    >
                      ‹
                    </button>
                    <button
                      className="media-nav-btn-desktop media-next-btn-desktop"
                      onClick={() => {
                        setSwipeDirection("left");
                        setCurrentImageIndex((prevIndex) =>
                          prevIndex === currentProductMedia.length - 1
                            ? 0
                            : prevIndex + 1,
                        );
                      }}
                    >
                      ›
                    </button>
                    {/* Thumbnail Indicators */}
                    <div className="media-thumbnails-container-desktop">
                      {currentProductMedia.map((media, idx) => (
                        <div
                          key={`thumb-${product.product_id}-${idx}-${currentImageIndex}`}
                          className={`media-thumbnail-desktop ${
                            idx === currentImageIndex ? "active" : ""
                          }`}
                          onClick={() => {
                            setSwipeDirection(
                              idx > currentImageIndex ? "left" : "right",
                            );
                            setCurrentImageIndex(idx);
                          }}
                        >
                          {media.type === "image" ? (
                            <img
                              src={media.url}
                              alt={`thumb-${product.product_id}-${idx}`}
                              className="media-thumbnail-image-desktop"
                            />
                          ) : (
                            <div className="media-thumbnail-icon-desktop">
                              <i className="white fa fa-play"></i>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>
            ) : (
              <div className="no-media-placeholder-desktop">
                <p>No Media Available</p>
              </div>
            )}
          </>
        ) : (
          <>
            {/* DESKTOP: Product Images/Media Slider */}
            {currentProductMedia.length > 0 ? (
              <div
                className="media-slider-container-desktop"
                {...sliderHandlers}
              >
                <AnimatePresence mode="wait">
                  {currentProductMedia[currentImageIndex]?.type === "image" && (
                    <motion.img
                      key={`product-image-${product.product_id}-${currentImageIndex}`}
                      src={currentProductMedia[currentImageIndex].url}
                      alt={`Product ${product.product_id} Preview ${currentImageIndex}`}
                      initial={{
                        opacity: 0,
                        x: swipeDirection === "left" ? 100 : -100,
                      }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{
                        opacity: 0,
                        x: swipeDirection === "left" ? -100 : 100,
                      }}
                      transition={{
                        x: {
                          type: "spring",
                          stiffness: 300,
                          damping: 30,
                        },
                        opacity: { duration: 0.2 },
                      }}
                      className="media-slider-image-desktop"
                      onClick={() => {
                        setSelectedMediaIndex(currentImageIndex);
                        setSelectedMedia(
                          currentProductMedia[currentImageIndex],
                        );
                        setSelectedProduct(product);
                        setRotation(0);
                        setScale(1);
                      }}
                    />
                  )}
                  {currentProductMedia[currentImageIndex]?.type === "video" && (
                    <motion.video
                      key={`product-video-${product.product_id}-${currentImageIndex}`}
                      controls
                      initial={{
                        opacity: 0,
                        x: swipeDirection === "left" ? 100 : -100,
                      }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{
                        opacity: 0,
                        x: swipeDirection === "left" ? -100 : 100,
                      }}
                      transition={{
                        x: {
                          type: "spring",
                          stiffness: 300,
                          damping: 30,
                        },
                        opacity: { duration: 0.2 },
                      }}
                      className="media-slider-video-desktop"
                      onClick={() => {
                        setSelectedMediaIndex(currentImageIndex);
                        setSelectedMedia(
                          currentProductMedia[currentImageIndex],
                        );
                        setSelectedProduct(product);
                      }}
                    >
                      <source
                        src={currentProductMedia[currentImageIndex].url}
                        type="video/mp4"
                      />
                      Your browser does not support the video tag.
                    </motion.video>
                  )}
                  {currentProductMedia[currentImageIndex]?.type ===
                    "youtube" && (
                    <motion.div
                      key={`product-youtube-${product.product_id}-${currentImageIndex}`}
                      initial={{
                        opacity: 0,
                        x: swipeDirection === "left" ? 100 : -100,
                      }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{
                        opacity: 0,
                        x: swipeDirection === "left" ? -100 : 100,
                      }}
                      transition={{
                        x: {
                          type: "spring",
                          stiffness: 300,
                          damping: 30,
                        },
                        opacity: { duration: 0.2 },
                      }}
                      className="media-slider-youtube-desktop"
                      onClick={() => {
                        setSelectedMediaIndex(currentImageIndex);
                        setSelectedMedia(
                          currentProductMedia[currentImageIndex],
                        );
                        setSelectedProduct(product);
                      }}
                    >
                      <iframe
                        src={currentProductMedia[currentImageIndex].url}
                        title="YouTube Video"
                        frameBorder="0"
                        allow="autoplay; encrypted-media"
                        className="youtube-iframe-desktop"
                      ></iframe>
                    </motion.div>
                  )}
                </AnimatePresence>
                {/* Media Navigation */}
                {currentProductMedia.length > 1 && (
                  <>
                    <button
                      className="media-nav-btn-desktop media-prev-btn-desktop"
                      onClick={() => {
                        setSwipeDirection("right");
                        setCurrentImageIndex((prevIndex) =>
                          prevIndex === 0
                            ? currentProductMedia.length - 1
                            : prevIndex - 1,
                        );
                      }}
                    >
                      ‹
                    </button>
                    <button
                      className="media-nav-btn-desktop media-next-btn-desktop"
                      onClick={() => {
                        setSwipeDirection("left");
                        setCurrentImageIndex((prevIndex) =>
                          prevIndex === currentProductMedia.length - 1
                            ? 0
                            : prevIndex + 1,
                        );
                      }}
                    >
                      ›
                    </button>
                    {/* Thumbnail Indicators */}
                    <div className="media-thumbnails-container-desktop">
                      {currentProductMedia.map((media, idx) => (
                        <div
                          key={`thumb-${product.product_id}-${idx}-${currentImageIndex}`}
                          className={`media-thumbnail-desktop ${
                            idx === currentImageIndex ? "active" : ""
                          }`}
                          onClick={() => {
                            setSwipeDirection(
                              idx > currentImageIndex ? "left" : "right",
                            );
                            setCurrentImageIndex(idx);
                          }}
                        >
                          {media.type === "image" ? (
                            <img
                              src={media.url}
                              alt={`thumb-${product.product_id}-${idx}`}
                              className="media-thumbnail-image-desktop"
                            />
                          ) : (
                            <div className="media-thumbnail-icon-desktop">
                              <i className="white fa fa-play"></i>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>
            ) : (
              <div className="no-media-placeholder-desktop">
                <p>No Media Available</p>
              </div>
            )}
          </>
        )}
        {/* Common product info section for both mobile and desktop */}
        <div
          className={`card card-style ${
            isMobile
              ? "mb-3 p-3 product-card-mobile"
              : "p-3 product-card-desktop"
          }`}
        >
          <div
            className={`product-details-section${isMobile ? "" : "-desktop"}`}
          >
            <div className={`product-actions${isMobile ? "" : "-desktop"}`}>
              <button
                onClick={() =>
                  handleLike(product.product_id, product.is_like === "1")
                }
                className={`like-btn${isMobile ? "" : "-desktop"} ${
                  product.is_like === "1" ? "liked" : ""
                }`}
              >
                <i
                  className={`fas fa-heart ${
                    product.is_like === "1" ? "redcolor" : ""
                  }`}
                />
                <span>
                  {product.product_total_likes > 0
                    ? product.product_total_likes
                    : ""}
                </span>
              </button>
              <button
                onClick={() => openCommentModal(product.product_id)}
                className={`comment-btn${isMobile ? "" : "-desktop"}`}
              >
                <i className="fas fa-comment" />
                <span>
                  {product.product_total_comment > 0
                    ? product.product_total_comment
                    : ""}
                </span>
              </button>
              {product.alert && (
                <span className={`product-alert${isMobile ? "" : "-desktop"}`}>
                  {product.alert}
                </span>
              )}
            </div>
            <div className={`product-actions${isMobile ? "" : "-desktop"}`}>
              <h5
                className={`product-title${isMobile ? "-mobile" : "-desktop"}`}
              >
                {product.product_design_name}
              </h5>
              {/* Price and Add to Cart - Right side */}
              <div
                className={`price-cart-container${
                  isMobile ? "-mobile" : "-desktop"
                }`}
              >
                {orderCount === "1" && (
                  <h2
                    className={`product-price${
                      isMobile ? "-mobile" : "-desktop"
                    }`}
                  >
                    {product.product_dealer_price !== product.product_mrp && (
                      <span
                        className={`original-price${
                          isMobile ? "" : "-desktop"
                        }`}
                      >
                        {product.product_mrp}
                      </span>
                    )}
                    {product.product_dealer_price}
                  </h2>
                )}
                {showStepper ? (
                  <div
                    className={`stepper-container${
                      isMobile ? "-mobile" : "-desktop"
                    } ${isUpdating ? "updating" : ""}`}
                  >
                    <button
                      className={`stepper-btn${
                        isMobile ? "" : "-desktop"
                      } stepper-sub${isMobile ? "" : "-desktop"}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        lastAddedProductRef.current = product.product_id;
                        handleButtonClick(product.product_id, "decrement");
                      }}
                      disabled={isUpdating}
                    >
                      <i className="redcolor fa fa-minus"></i>
                    </button>
                    <input
                      type="number"
                      min="0"
                      max="99"
                      value={currentQuantity}
                      onChange={(e) => {
                        lastAddedProductRef.current = product.product_id;
                        handleQuantityChange(
                          product.product_id,
                          e.target.value,
                        );
                      }}
                      className={`stepper-input${
                        isMobile ? "-mobile" : "-desktop"
                      }`}
                      disabled={isUpdating}
                      id={`main-quantity-input-${product.product_id}`}
                      name={`main-quantity-${product.product_id}`}
                      autoComplete="off"
                    />
                    <button
                      className={`stepper-btn${
                        isMobile ? "" : "-desktop"
                      } stepper-add${isMobile ? "" : "-desktop"}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        lastAddedProductRef.current = product.product_id;
                        handleButtonClick(product.product_id, "increment");
                      }}
                      disabled={isUpdating}
                    >
                      <i className="redcolor fa fa-plus"></i>
                    </button>
                  </div>
                ) : (
                  <button
                    className={`add-to-cart-btn${
                      isMobile ? "-mobile" : "-desktop"
                    } ${isUpdating ? "updating" : ""}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      lastAddedProductRef.current = product.product_id;
                      handleAddClick(product.product_id);
                    }}
                    disabled={isUpdating}
                  >
                    <i className="white fa fa-plus"></i>
                  </button>
                )}
              </div>
            </div>
            {!showMoreDetails && (
              <p
                className={`view-more-link${isMobile ? "" : "-desktop"}`}
                onClick={() => setShowMoreDetails(true)}
              >
                View more{" "}
                <span
                  style={{
                    color: "rgb(79 190 19)",
                    float: "right",
                    fontSize: "14px",
                  }}
                >
                  <b>{product.product_stock_text}</b>
                </span>
              </p>
            )}
            {showMoreDetails && (
              <>
                <p className="mb-1" style={{ color: textColor }}>
                  <strong>Size:</strong> {product.size_name || "-"}{" "}
                </p>
                <p className="mb-1" style={{ color: textColor }}>
                  <strong>Per Box:</strong>{" "}
                  {product.product_piece_per_box || "0"}
                </p>
                <p className="mb-1" style={{ color: textColor }}>
                  <strong>Code:</strong> {product.product_name || "-"}
                </p>
                <p className="mb-1" style={{ color: textColor }}>
                  <strong>Series:</strong> {product.series_name || "-"}
                </p>
                <p className="mb-1" style={{ color: textColor }}>
                  <strong>Grade:</strong> {product.product_grade || "-"}
                </p>
                <p className="mb-1" style={{ color: textColor }}>
                  <strong>Repeat Order Time:</strong>{" "}
                  {product.product_repeat_order_time_in_days || "0"} Days
                </p>
                <p className="mb-1" style={{ color: textColor }}>
                  <strong>Weight:</strong>{" "}
                  {product.product_weight_per_box || "0"}
                </p>
                <p
                  className={`view-more-link${isMobile ? "" : "-desktop"}`}
                  onClick={() => setShowMoreDetails(false)}
                >
                  Hide details
                  <span
                    style={{
                     color: "rgb(79 190 19)",
                      float: "right",
                      fontSize: "14px",
                    }}
                  >
                    <b>{product.product_stock_text}</b>
                  </span>
                </p>
              </>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  };
  const SkeletonDetails = ({ isMobile }) => (
    <div className="skeleton-product-details">
      <div className="skeleton-image"></div>
      <div className="skeleton-content">
        <div className="skeleton-title"></div>
        <div className="skeleton-price"></div>
        <div className="skeleton-buttons">
          <div className="skeleton-button"></div>
        </div>
      </div>
    </div>
  );

  
  const SkeletonCard = () => (
    <div className="skeleton-card">
      <div className="skeleton-card-image"></div>
      <div className="skeleton-card-title"></div>
      <div className="skeleton-card-price"></div>
    </div>
  );
  return (
    <>
      <Helmet>
        <title>
          {productDetails[0]?.seo_content_title ||
            `${productDetails[0]?.product_design_name || "Product"} | AG Home Decor`}
        </title>
        <meta
          name="description"
          content={
            productDetails[0]?.seo_content_description ||
            `Buy ${productDetails[0]?.product_design_name || "this product"} from AG Home Decor. High-quality decorative tiles and ceramic products.`
          }
        />
        <meta
          name="keywords"
          content={
            productDetails[0]?.seo_content_keyword ||
            `${productDetails[0]?.product_design_name || "decorative tiles"}, AG Home Decor, ceramic tiles, wall tiles, floor tiles, Morbi`
          }
        />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="product" />
        <meta
          property="og:title"
          content={
            productDetails[0]?.seo_content_title ||
            `${productDetails[0]?.product_design_name || "Product"} - AG Home Decor`
          }
        />
        <meta
          property="og:description"
          content={
            productDetails[0]?.seo_content_description ||
            `Premium ${productDetails[0]?.product_design_name || "decorative tile"} from AG Home Decor`
          }
        />
        <meta
          property="og:image"
          content={
            productDetails[0]?.product_image ||
            "https://aghomedecor.in/AGLOGO.png"
          }
        />
        <meta
          property="og:url"
          content={`https://aghomedecor.in/ProductDetails/${product_id}/${product_name}`}
        />
        <meta property="og:site_name" content="AG Home Decor" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content={
            productDetails[0]?.seo_content_title ||
            `${productDetails[0]?.product_design_name || "Product"} - AG Home Decor`
          }
        />
        <meta
          name="twitter:description"
          content={
            productDetails[0]?.seo_content_description ||
            `Premium ${productDetails[0]?.product_design_name || "decorative tile"} from AG Home Decor`
          }
        />
        <meta
          name="twitter:image"
          content={
            productDetails[0]?.product_image ||
            "https://aghomedecor.in/AGLOGO.png"
          }
        />
        <meta name="twitter:site" content="@AGHomeDecor" />
        <meta name="twitter:creator" content="AG Home Decor" />

        {/* Additional Meta Tags */}
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="robots" content="index, follow" />

        {/* Canonical URL */}
        <link
          rel="canonical"
          href={`https://aghomedecor.in/ProductDetails/${product_id}/${product_name}`}
        />
      </Helmet>
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: backgroundColor,
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "50px",
              height: "50px",
              border: `4px solid ${borderColor}`,
              borderTop: `4px solid ${accentColor}`,
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
            }}
          ></div>
        </div>
      )}
      <div
        className="page-wrapper"
        style={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          position: "relative",
        }}
      >
        <div
          className="page-content"
          style={{
            flex: "1 0 auto",
            width: "100%",
            paddingBottom: "env(safe-area-inset-bottom)",
          }}
        >
          <Header />
          {/* Content */}
          <div style={{}}>
            {isMobile ? (
              <div key="mobile-container" className="mobile-product-container">
                {productDetails.map((product, index) => (
                  <React.Fragment
                    key={`mobile-product-detail-${product.product_id}-${index}`}
                  >
                    {isDetailLoading ? (
                      <SkeletonDetails isMobile={true} />
                    ) : (
                      renderProductDetails(product, true)
                    )}
                  </React.Fragment>
                ))}
              </div>
            ) : (
              <div key="desktop-container" className="desktop-layout-container">
                {/* LEFT 50%: Product Details + Odd Products */}
                <div
                  key="left-section"
                  className="left-desktop-section"
                  style={{ paddingTop: isMobile ? "85px":  "10px"}}
                >
                  {/* Product Details */}
                  {productDetails.map((product, index) => (
                    <React.Fragment
                      key={`desktop-product-detail-${product.product_id}-${index}`}
                    >
                      {isDetailLoading ? (
                        <SkeletonDetails isMobile={false} />
                      ) : (
                        renderProductDetails(product, false)
                      )}
                    </React.Fragment>
                  ))}
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: `repeat(${Math.ceil(
                        columnCount / 2,
                      )}, 1fr)`,
                      gap: "10px",
                      marginLeft: "10px",
                      alignItems: "start",
                    }}
                  >
                    {isLoading
                      ? distributeProductsByColumns(
                          Array(Math.ceil(columnCount / 2) * 4).fill({}),
                          Math.ceil(columnCount / 2),
                        ).map((column, colIndex) => (
                          <div
                            key={colIndex}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: isMobile ? "0px" : "5px",
                            }}
                          >
                            {column.map((_, index) => (
                              <SkeletonCard key={index} />
                            ))}
                          </div>
                        ))
                      : oddColumns.map((column, colIndex) => (
                          <div
                            key={colIndex}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: isMobile ? "0px" : "5px",
                            }}
                          >
                            {column.map((product, index) => {
                              const isLastColumn =
                                colIndex === oddColumns.length - 1;
                              const isLastProductInColumn =
                                index === column.length - 1;
                              const isLastProductOverall =
                                isLastColumn && isLastProductInColumn;
                              return (
                                <div
                                  key={product.product_id}
                                  ref={(el) => {
                                    if (el) {
                                      productRefs.current[product.product_id] =
                                        el;
                                      if (
                                        isLastProductOverall &&
                                        loadedPages.size < allPageKeys.length &&
                                        !searchTerm
                                      ) {
                                        lastProductRef(el);
                                      }
                                    }
                                  }}
                                  style={{
                                    borderRadius: "8px",
                                    position: "relative",
                                  }}
                                  className={
                                    addingProducts.has(product.product_id)
                                      ? "updating"
                                      : ""
                                  }
                                >
                                  <div
                                    style={{
                                      position: "relative",
                                      borderRadius: "8px",
                                      overflow: "hidden",
                                      border: `1px solid ${borderColor}`,
                                    }}
                                    className="Hoverred"
                                  >
                                    <Link
                                      to={`/ProductDetailss/${
                                        product.product_id
                                      }/${product.product_design_name
                                        .trim()
                                        .split(/\s+/)
                                        .map(
                                          (word) =>
                                            word.charAt(0).toUpperCase() +
                                            word.slice(1).toLowerCase(),
                                        )
                                        .join("")}`}
                                      onClick={() =>
                                        handleProductClick(product.product_id)
                                      }
                                      state={{ from: "AddProduct" }}
                                    >
                                      <img
                                        src={product.product_image}
                                        alt={product.product_design_name}
                                        style={{
                                          width: "100%",
                                          height: "auto",
                                          objectFit: "fill",
                                          borderRadius: "8px",
                                        }}
                                        loading="lazy"
                                      />
                                    </Link>
                                    {product.alert && (
                                      <div
                                        style={{
                                          position: "absolute",
                                          top: "0px",
                                          right: "0px",
                                          background: "#DB4437", // Red alert background
                                          color: "#ffffff",
                                          padding: "0px 7px",
                                          borderRadius: "0px 0px 0px 10px",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {product.alert}
                                      </div>
                                    )}
                                    <div
                                      style={{
                                        position: "absolute",
                                        bottom: "3px",
                                        right: "3px",
                                      }}
                                    >
                                      {showSteppers.get(product.product_id) ? (
                                        <div
                                          style={{
                                            background:
                                              "rgba(255, 255, 255, 0.9)",
                                            borderRadius: "8px",
                                            display: "flex",
                                            alignItems: "center",
                                            width: "100px",
                                            height: "30px",
                                            border: `1px solid ${accentColor}`,
                                          }}
                                        >
                                          <button
                                            style={{
                                              padding: "8px",
                                              color: accentColor,
                                              background: "transparent",
                                              border: "none",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              handleButtonClick(
                                                product.product_id,
                                                "decrement",
                                              )
                                            }
                                            onMouseDown={() =>
                                              handleButtonHold(
                                                product.product_id,
                                                "decrement",
                                              )
                                            }
                                            onTouchStart={() =>
                                              handleButtonHold(
                                                product.product_id,
                                                "decrement",
                                              )
                                            }
                                          >
                                            <i className="redcolor fa fa-minus"></i>
                                          </button>
                                          <input
                                            type="number"
                                            min="0"
                                            max="99"
                                            value={
                                              quantityInputs[
                                                product.product_id
                                              ] ?? product.product_quantity
                                            }
                                            onChange={(e) =>
                                              handleQuantityChange(
                                                product.product_id,
                                                e.target.value,
                                              )
                                            }
                                            style={{
                                              width: "40px",
                                              textAlign: "center",
                                              background: "transparent",
                                              border: "none",
                                              color: "#000",
                                            }}
                                          />
                                          <button
                                            style={{
                                              padding: "8px",
                                              background: "transparent",
                                              border: "none",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              handleButtonClick(
                                                product.product_id,
                                                "increment",
                                              )
                                            }
                                            onMouseDown={() =>
                                              handleButtonHold(
                                                product.product_id,
                                                "increment",
                                              )
                                            }
                                            onTouchStart={() =>
                                              handleButtonHold(
                                                product.product_id,
                                                "increment",
                                              )
                                            }
                                          >
                                            <i
                                              className="redcolor fa fa-plus"
                                              style={{ color: accentColor }}
                                            ></i>
                                          </button>
                                        </div>
                                      ) : (
                                        <button
                                          onClick={() =>
                                            handleAddClick(product.product_id)
                                          }
                                          style={{
                                            background: accentColor,
                                            color: "white",
                                            border: "none",
                                            borderRadius: "10px",
                                            padding: "5px 8px",
                                          }}
                                        >
                                          <i
                                            className="white fa fa-plus"
                                            style={{ fontSize: "20px" }}
                                          ></i>
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                  <Link
                                    to={`/ProductDetailss/${product.product_id}`}
                                    onClick={() =>
                                      handleProductClick(product.product_id)
                                    }
                                    state={{ from: "AddProduct" }}
                                  >
                                    <h4
                                      style={{
                                        fontSize: "14px",
                                        margin: "0px 0 0",
                                        color: textColor,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                      }}
                                    >
                                      {product.product_design_name}
                                    </h4>
                                  </Link>
                                </div>
                              );
                            })}
                          </div>
                        ))}
                  </div>
                  {/* Loading More - Only show when not searching */}
                  {isLoadingMore && !searchTerm && (
                    <div
                      style={{
                        textAlign: "center",
                        padding: "20px 0",
                        gridColumn: `1 / span ${Math.ceil(columnCount / 2)}`,
                      }}
                    >
                      <div
                        style={{
                          display: "inline-block",
                          width: "30px",
                          height: "30px",
                          border: `3px solid ${borderColor}`,
                          borderTop: `3px solid ${accentColor}`,
                          borderRadius: "50%",
                          animation: "spin 1s linear infinite",
                        }}
                      ></div>
                    </div>
                  )}
                </div>
                <div
                  key="right-section"
                  className="right-desktop-section"
                  style={{ paddingTop: "12px" }}
                >
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: `repeat(${Math.floor(
                        columnCount / 2,
                      )}, 1fr)`,
                      gap: "10px",
                      marginRight: "10px",
                      alignItems: "start",
                    }}
                  >
                    {isLoading
                      ? distributeProductsByColumns(
                          Array(Math.floor(columnCount / 2) * 4).fill({}),
                          Math.floor(columnCount / 2),
                        ).map((column, colIndex) => (
                          <div
                            key={colIndex}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: isMobile ? "0px" : "5px",
                            }}
                          >
                            {column.map((_, index) => (
                              <SkeletonCard key={index} />
                            ))}
                          </div>
                        ))
                      : evenColumns.map((column, colIndex) => (
                          <div
                            key={colIndex}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: isMobile ? "0px" : "5px",
                            }}
                          >
                            {column.map((product, index) => {
                              const isLastColumn =
                                colIndex === evenColumns.length - 1;
                              const isLastProductInColumn =
                                index === column.length - 1;
                              const isLastProductOverall =
                                isLastColumn && isLastProductInColumn;
                              return (
                                <div
                                  key={product.product_id}
                                  ref={(el) => {
                                    if (el) {
                                      productRefs.current[product.product_id] =
                                        el;
                                      if (
                                        isLastProductOverall &&
                                        loadedPages.size < allPageKeys.length &&
                                        !searchTerm
                                      ) {
                                        lastProductRef(el);
                                      }
                                    }
                                  }}
                                  style={{
                                    borderRadius: "8px",
                                    position: "relative",
                                  }}
                                  className={
                                    addingProducts.has(product.product_id)
                                      ? "updating"
                                      : ""
                                  }
                                >
                                  <div
                                    style={{
                                      position: "relative",
                                      borderRadius: "8px",
                                      overflow: "hidden",
                                      border: `1px solid ${borderColor}`,
                                    }}
                                    className="Hoverred"
                                  >
                                    <Link
                                      to={`/ProductDetailss/${
                                        product.product_id
                                      }/${product.product_design_name
                                        .trim()
                                        .split(/\s+/)
                                        .map(
                                          (word) =>
                                            word.charAt(0).toUpperCase() +
                                            word.slice(1).toLowerCase(),
                                        )
                                        .join("")}`}
                                      onClick={() =>
                                        handleProductClick(product.product_id)
                                      }
                                      state={{ from: "AddProduct" }}
                                    >
                                      <img
                                        src={product.product_image}
                                        alt={product.product_design_name}
                                        style={{
                                          width: "100%",
                                          height: "auto",
                                          objectFit: "fill",
                                          borderRadius: "8px",
                                        }}
                                        loading="lazy"
                                      />
                                    </Link>
                                    {product.alert && (
                                      <div
                                        style={{
                                          position: "absolute",
                                          top: "0px",
                                          right: "0px",
                                          background: "#DB4437", // Red alert background
                                          color: "#ffffff",
                                          padding: "0px 7px",
                                          borderRadius: "0px 0px 0px 10px",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {product.alert}
                                      </div>
                                    )}
                                    <div
                                      style={{
                                        position: "absolute",
                                        bottom: "3px",
                                        right: "3px",
                                      }}
                                    >
                                      {showSteppers.get(product.product_id) ? (
                                        <div
                                          style={{
                                            background:
                                              "rgba(255, 255, 255, 0.9)",
                                            borderRadius: "8px",
                                            display: "flex",
                                            alignItems: "center",
                                            width: "100px",
                                            height: "30px",
                                            border: `1px solid ${accentColor}`,
                                          }}
                                        >
                                          <button
                                            style={{
                                              padding: "8px",
                                              color: accentColor,
                                              background: "transparent",
                                              border: "none",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              handleButtonClick(
                                                product.product_id,
                                                "decrement",
                                              )
                                            }
                                            onMouseDown={() =>
                                              handleButtonHold(
                                                product.product_id,
                                                "decrement",
                                              )
                                            }
                                            onTouchStart={() =>
                                              handleButtonHold(
                                                product.product_id,
                                                "decrement",
                                              )
                                            }
                                          >
                                            <i className="redcolor fa fa-minus"></i>
                                          </button>
                                          <input
                                            type="number"
                                            min="0"
                                            max="99"
                                            value={
                                              quantityInputs[
                                                product.product_id
                                              ] ?? product.product_quantity
                                            }
                                            onChange={(e) =>
                                              handleQuantityChange(
                                                product.product_id,
                                                e.target.value,
                                              )
                                            }
                                            style={{
                                              width: "40px",
                                              textAlign: "center",
                                              background: "transparent",
                                              border: "none",
                                              color: "#000",
                                            }}
                                          />
                                          <button
                                            style={{
                                              padding: "8px",
                                              background: "transparent",
                                              border: "none",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              handleButtonClick(
                                                product.product_id,
                                                "increment",
                                              )
                                            }
                                            onMouseDown={() =>
                                              handleButtonHold(
                                                product.product_id,
                                                "increment",
                                              )
                                            }
                                            onTouchStart={() =>
                                              handleButtonHold(
                                                product.product_id,
                                                "increment",
                                              )
                                            }
                                          >
                                            <i
                                              className="redcolor fa fa-plus"
                                              style={{ color: accentColor }}
                                            ></i>
                                          </button>
                                        </div>
                                      ) : (
                                        <button
                                          onClick={() =>
                                            handleAddClick(product.product_id)
                                          }
                                          style={{
                                            background: accentColor,
                                            color: "white",
                                            border: "none",
                                            borderRadius: "10px",
                                            padding: "5px 8px",
                                          }}
                                        >
                                          <i
                                            className="white fa fa-plus"
                                            style={{ fontSize: "20px" }}
                                          ></i>
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                  <Link
                                    to={`/ProductDetailss/${product.product_id}`}
                                    onClick={() =>
                                      handleProductClick(product.product_id)
                                    }
                                    state={{ from: "AddProduct" }}
                                  >
                                    <h4
                                      style={{
                                        fontSize: "14px",
                                        margin: "0px 0 0",
                                        color: textColor,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                      }}
                                    >
                                      {product.product_design_name}
                                    </h4>
                                  </Link>
                                </div>
                              );
                            })}
                          </div>
                        ))}
                  </div>
                  {/* Loading More - Only show when not searching */}
                  {isLoadingMore && !searchTerm && (
                    <div
                      style={{
                        textAlign: "center",
                        padding: "20px 0",
                        gridColumn: `1 / span ${Math.floor(columnCount / 2)}`,
                      }}
                    >
                      <div
                        style={{
                          display: "inline-block",
                          width: "30px",
                          height: "30px",
                          border: `3px solid ${borderColor}`,
                          borderTop: `3px solid ${accentColor}`,
                          borderRadius: "50%",
                          animation: "spin 1s linear infinite",
                        }}
                      ></div>
                    </div>
                  )}
                </div>
              </div>
            )}
            {isMobile && (
              <div
                className="container"
                style={{ padding: "0 15px", maxWidth: "100%" }}
              >
                {/* SINGLE GRID CONTAINER - Products distributed vertically */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: `repeat(${columnCount}, 1fr)`,
                    gap: "10px",
                    alignItems: "start",
                  }}
                >
                  {isLoading
                    ? distributeProductsByColumns(
                        Array(columnCount * 4).fill({}),
                        columnCount,
                      ).map((column, colIndex) => (
                        <div
                          key={colIndex}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: isMobile ? "0px" : "5px",
                          }}
                        >
                          {column.map((_, index) => (
                            <SkeletonCard key={index} />
                          ))}
                        </div>
                      ))
                    : productColumns.map((column, colIndex) => (
                        <div
                          key={colIndex}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: isMobile ? "0px" : "5px",
                          }}
                        >
                          {column.map((product, index) => {
                            const isLastColumn =
                              colIndex === productColumns.length - 1;
                            const isLastProductInColumn =
                              index === column.length - 1;
                            const isLastProductOverall =
                              isLastColumn && isLastProductInColumn;
                            return (
                              <div
                                key={product.product_id}
                                ref={(el) => {
                                  if (el) {
                                    productRefs.current[product.product_id] =
                                      el;
                                    if (
                                      isLastProductOverall &&
                                      loadedPages.size < allPageKeys.length &&
                                      !searchTerm
                                    ) {
                                      lastProductRef(el);
                                    }
                                  }
                                }}
                                style={{
                                  borderRadius: "8px",
                                  position: "relative",
                                }}
                                className={
                                  addingProducts.has(product.product_id)
                                    ? "updating"
                                    : ""
                                }
                              >
                                <div
                                  style={{
                                    position: "relative",
                                    borderRadius: "8px",
                                    overflow: "hidden",
                                    border: `1px solid ${borderColor}`,
                                  }}
                                  className="Hoverred"
                                >
                                  <Link
                                    to={`/ProductDetailss/${
                                      product.product_id
                                    }/${product.product_design_name
                                      .trim()
                                      .split(/\s+/)
                                      .map(
                                        (word) =>
                                          word.charAt(0).toUpperCase() +
                                          word.slice(1).toLowerCase(),
                                      )
                                      .join("")}`}
                                    onClick={() =>
                                      handleProductClick(product.product_id)
                                    }
                                    state={{ from: "AddProduct" }}
                                  >
                                    <img
                                      src={product.product_image}
                                      alt={product.product_design_name}
                                      style={{
                                        width: "100%",
                                        height: "auto",
                                        objectFit: "fill",
                                        borderRadius: "8px",
                                      }}
                                      loading="lazy"
                                    />
                                  </Link>
                                  {product.alert && (
                                    <div
                                      style={{
                                        position: "absolute",
                                        top: "0px",
                                        right: "0px",
                                        background: "#DB4437", // Red alert background
                                        color: "#ffffff",
                                        padding: "0px 7px",
                                        borderRadius: "0px 0px 0px 10px",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {product.alert}
                                    </div>
                                  )}
                                  <div
                                    style={{
                                      position: "absolute",
                                      bottom: "3px",
                                      right: "3px",
                                    }}
                                  >
                                    {showSteppers.get(product.product_id) ? (
                                      <div
                                        style={{
                                          background:
                                            "rgba(255, 255, 255, 0.9)",
                                          borderRadius: "8px",
                                          display: "flex",
                                          alignItems: "center",
                                          width: "100px",
                                          height: "30px",
                                          border: `1px solid ${accentColor}`,
                                        }}
                                      >
                                        <button
                                          style={{
                                            padding: "8px",
                                            color: accentColor,
                                            background: "transparent",
                                            border: "none",
                                            cursor: "pointer",
                                          }}
                                          onClick={() =>
                                            handleButtonClick(
                                              product.product_id,
                                              "decrement",
                                            )
                                          }
                                          onMouseDown={() =>
                                            handleButtonHold(
                                              product.product_id,
                                              "decrement",
                                            )
                                          }
                                          onTouchStart={() =>
                                            handleButtonHold(
                                              product.product_id,
                                              "decrement",
                                            )
                                          }
                                        >
                                          <i className="white fa fa-minus"></i>
                                        </button>
                                        <input
                                          type="number"
                                          min="0"
                                          max="99"
                                          value={
                                            quantityInputs[
                                              product.product_id
                                            ] ?? product.product_quantity
                                          }
                                          onChange={(e) =>
                                            handleQuantityChange(
                                              product.product_id,
                                              e.target.value,
                                            )
                                          }
                                          style={{
                                            width: "40px",
                                            textAlign: "center",
                                            background: "transparent",
                                            border: "none",
                                            color: "#000",
                                          }}
                                        />
                                        <button
                                          style={{
                                            padding: "8px",
                                            background: "transparent",
                                            border: "none",
                                            cursor: "pointer",
                                          }}
                                          onClick={() =>
                                            handleButtonClick(
                                              product.product_id,
                                              "increment",
                                            )
                                          }
                                          onMouseDown={() =>
                                            handleButtonHold(
                                              product.product_id,
                                              "increment",
                                            )
                                          }
                                          onTouchStart={() =>
                                            handleButtonHold(
                                              product.product_id,
                                              "increment",
                                            )
                                          }
                                        >
                                          <i
                                            className="white fa fa-plus"
                                            style={{ color: accentColor }}
                                          ></i>
                                        </button>
                                      </div>
                                    ) : (
                                      <button
                                        onClick={() =>
                                          handleAddClick(product.product_id)
                                        }
                                        style={{
                                          background: accentColor,
                                          color: "white",
                                          border: "none",
                                          borderRadius: "10px",
                                          padding: "5px 8px",
                                        }}
                                      >
                                        <i
                                          className="white fa fa-plus"
                                          style={{ fontSize: "20px" }}
                                        ></i>
                                      </button>
                                    )}
                                  </div>
                                </div>
                                <Link
                                  to={`/ProductDetailss/${product.product_id}`}
                                  onClick={() =>
                                    handleProductClick(product.product_id)
                                  }
                                  state={{ from: "AddProduct" }}
                                >
                                  <h4
                                    style={{
                                      fontSize: "14px",
                                      margin: "0px 0 0",
                                      color: textColor,
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    {product.product_design_name}
                                  </h4>
                                </Link>
                              </div>
                            );
                          })}
                        </div>
                      ))}
                </div>
                {/* Loading More - Only show when not searching */}
                {isLoadingMore && !searchTerm && (
                  <div
                    style={{
                      textAlign: "center",
                      padding: "20px 0",
                      gridColumn: `1 / span ${columnCount}`,
                    }}
                  >
                    <div
                      style={{
                        display: "inline-block",
                        width: "30px",
                        height: "30px",
                        border: `3px solid ${borderColor}`,
                        borderTop: `3px solid ${accentColor}`,
                        borderRadius: "50%",
                        animation: "spin 1s linear infinite",
                      }}
                    ></div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Media Modal */}
        <AnimatePresence>
          {selectedMedia && selectedProduct && (
            <motion.div
              className="modal fade show media-modal"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
            >
              <div className="modal-dialog modal-dialog-centered media-modal-dialog">
                <div className="modal-content media-modal-content">
                  <div className="modal-body media-modal-body">
                    <TransformWrapper
                      ref={transformRef}
                      initialScale={1}
                      minScale={1}
                      maxScale={selectedMedia.type === "image" ? 5 : 1}
                      panning={{ disabled: scale === 1 }}
                      doubleClick={{ disabled: true }}
                      wheel={{
                        step: 0.1,
                        disabled: selectedMedia.type !== "image",
                      }}
                      pinch={{ disabled: selectedMedia.type !== "image" }}
                      onTransformed={(ref, state) => setScale(state.scale)}
                    >
                      <TransformComponent
                        wrapperStyle={{
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          overflow: "hidden",
                        }}
                        contentStyle={{
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <div className="media-modal-transform-content">
                          <AnimatePresence mode="wait">
                            {selectedMedia.type === "image" && (
                              <motion.img
                                key={`modal-image-${selectedProduct.product_id}-${selectedMediaIndex}`}
                                src={selectedMedia.url}
                                alt="Preview"
                                initial={{
                                  x: swipeDirection === "left" ? 100 : -100,
                                  opacity: 0,
                                }}
                                animate={{
                                  x: 0,
                                  opacity: 1,
                                  rotate: rotation,
                                }}
                                exit={{
                                  x: swipeDirection === "left" ? -100 : 100,
                                  opacity: 0,
                                }}
                                transition={{
                                  x: {
                                    type: "spring",
                                    stiffness: 300,
                                    damping: 30,
                                  },
                                  opacity: { duration: 0.2 },
                                }}
                                className="media-modal-image"
                              />
                            )}
                            {selectedMedia.type === "video" && (
                              <motion.video
                                key={`modal-video-${selectedProduct.product_id}-${selectedMediaIndex}`}
                                controls
                                autoPlay
                                initial={{
                                  x: swipeDirection === "left" ? 100 : -100,
                                  opacity: 0,
                                }}
                                animate={{
                                  x: 0,
                                  opacity: 1,
                                }}
                                exit={{
                                  x: swipeDirection === "left" ? -100 : 100,
                                  opacity: 0,
                                }}
                                transition={{
                                  x: {
                                    type: "spring",
                                    stiffness: 300,
                                    damping: 30,
                                  },
                                  opacity: { duration: 0.2 },
                                }}
                                className="media-modal-video"
                              >
                                <source
                                  src={selectedMedia.url}
                                  type="video/mp4"
                                />
                                Your browser does not support the video tag.
                              </motion.video>
                            )}
                            {selectedMedia.type === "youtube" && (
                              <motion.div
                                key={`modal-youtube-${selectedProduct.product_id}-${selectedMediaIndex}`}
                                initial={{
                                  x: swipeDirection === "left" ? 100 : -100,
                                  opacity: 0,
                                }}
                                animate={{
                                  x: 0,
                                  opacity: 1,
                                }}
                                exit={{
                                  x: swipeDirection === "left" ? -100 : 100,
                                  opacity: 0,
                                }}
                                transition={{
                                  x: {
                                    type: "spring",
                                    stiffness: 300,
                                    damping: 30,
                                  },
                                  opacity: { duration: 0.2 },
                                }}
                                className="media-modal-youtube"
                              >
                                <iframe
                                  src={selectedMedia.url}
                                  title="YouTube Video"
                                  frameBorder="0"
                                  allow="autoplay; encrypted-media"
                                  className="media-modal-youtube-iframe"
                                ></iframe>
                              </motion.div>
                            )}
                          </AnimatePresence>
                        </div>
                      </TransformComponent>
                    </TransformWrapper>

                    {selectedMedia.type === "image" && (
                      <>
                        <button
                          className="btn btn-secondary rotate-btn rotate-left"
                          onClick={() => setRotation((prev) => prev - 90)}
                        >
                          ↺
                        </button>
                        <button
                          className="btn btn-secondary rotate-btn rotate-right"
                          onClick={() => setRotation((prev) => prev + 90)}
                        >
                          ↻
                        </button>
                      </>
                    )}

                    <button
                      className="btn btn-light media-nav-btn-modal media-prev-btn-modal"
                      onClick={() => {
                        const mediaList = getAllMediaItems(selectedProduct);
                        const newIndex =
                          selectedMediaIndex === 0
                            ? mediaList.length - 1
                            : selectedMediaIndex - 1;
                        changeMedia(newIndex, "right");
                      }}
                    >
                      ‹
                    </button>
                    <button
                      className="btn btn-light media-nav-btn-modal media-next-btn-modal"
                      onClick={() => {
                        const mediaList = getAllMediaItems(selectedProduct);
                        const newIndex =
                          selectedMediaIndex === mediaList.length - 1
                            ? 0
                            : selectedMediaIndex + 1;
                        changeMedia(newIndex, "left");
                      }}
                    >
                      ›
                    </button>

                    {getAllMediaItems(selectedProduct).length > 0 && (
                      <div className="media-modal-thumbnails">
                        {getAllMediaItems(selectedProduct).map((media, idx) => (
                          <div
                            key={`modal-thumb-${selectedProduct.product_id}-${idx}-${selectedMediaIndex}`}
                            className={`media-modal-thumbnail ${
                              idx === selectedMediaIndex ? "active" : ""
                            }`}
                            onClick={() => {
                              const direction =
                                idx > selectedMediaIndex ? "left" : "right";
                              changeMedia(idx, direction);
                            }}
                          >
                            {media.type === "image" ? (
                              <img
                                src={media.url}
                                alt={`modal-thumb-${selectedProduct.product_id}-${idx}`}
                                className="media-modal-thumbnail-image"
                              />
                            ) : (
                              <div className="media-modal-thumbnail-icon">
                                <i className="white fa fa-play"></i>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}

                    <button
                      className="btn btn-danger media-modal-close-btn"
                      onClick={() => {
                        setSelectedMedia(null);
                        setSelectedMediaIndex(null);
                        setRotation(0);
                        setSwipeDirection(null);
                        setScale(1);
                      }}
                    >
                      ✕
                    </button>
                  </div>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
        {isMobile ? (
          <>
            {" "}
            <br />
            <br />
            <br />{" "}
          </>
        ) : (
          <br />
        )}
        {/* Comment Modal */}
        {showCommentModal && (
          <div className="comment-modal">
            <div className="comment-modal-content">
              <h2>Comments</h2>
              <button
                onClick={() => setShowCommentModal(false)}
                className="comment-modal-close"
              >
                &times;
              </button>
              <div className="comment-list">
                {comments.length > 0 ? (
                  comments.map((comment, index) => (
                    <div
                      key={`comment-${comment.promotion_comment_id}-${index}-${selectedProductId}`}
                      className="comment-item"
                    >
                      <table>
                        <tbody>
                          <tr>
                            <td className="comment-text-cell">
                              {comment.promotion_comment}
                            </td>
                            <td className="comment-action-cell">
                              <span>
                                {comment.promotion_comment_by === loginId && (
                                  <button
                                    onClick={() =>
                                      handleDeleteComment(
                                        comment.promotion_comment_id,
                                      )
                                    }
                                    className="delete-comment-btn"
                                  >
                                    <i
                                      className="white fa fa-trash"
                                      aria-hidden="true"
                                    />
                                  </button>
                                )}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <span>
                        <span className="comment-meta">
                          {comment.dealer_firm_name}
                          <br />
                          {comment.c_date}
                        </span>
                      </span>
                    </div>
                  ))
                ) : (
                  <p>No comments yet.</p>
                )}
              </div>
              <div className="comment-input-container">
                <input
                  type="text"
                  value={commentText}
                  onChange={(e) => setCommentText(e.target.value)}
                  placeholder="Add a comment..."
                  className="comment-input"
                  onKeyPress={(e) => e.key === "Enter" && handleCommentSubmit()}
                  id="comment-input"
                  name="comment"
                  autoComplete="off"
                />
                <button
                  onClick={handleCommentSubmit}
                  className="comment-submit-btn"
                >
                  Post
                </button>
              </div>
            </div>
          </div>
        )}
        {/* Delete Confirmation Modal */}
        {showDeleteConfirm && (
          <div className="delete-confirm-modal">
            <div className="delete-confirm-content">
              <p className="delete-confirm-message">
                Are you sure you want to delete this comment?
              </p>
              <div className="delete-confirm-buttons">
                <button
                  onClick={confirmDeleteComment}
                  className="confirm-delete-btn"
                >
                  Yes
                </button>
                <button
                  onClick={() => setShowDeleteConfirm(false)}
                  className="cancel-delete-btn"
                >
                  No
                </button>
              </div>
            </div>
          </div>
        )}
        {/* Footer - Always at bottom */}
        <div
          style={{
            flexShrink: 0,
            width: "100%",
            marginTop: "auto",
          }}
        >
          <Footer />
        </div>
      </div>
      <style jsx>{`
        /* Theme Variables */
        :root {
          --primary-bg: ${backgroundColor};
          --text-primary: ${textColor};
          --text-secondary: ${textSecondary};
          --accent-color: ${accentColor};
          --border-color: ${borderColor};
          --card-shadow: ${cardShadow};
          --hover-shadow: ${hoverShadow};
        }

        .Hoverred:hover {
          border-color: var(--accent-color) !important;
          transform: scale(1.01);
          box-shadow: var(--hover-shadow);
        }

        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
        input[type="number"]::-webkit-inner-spin-button,
        input[type="number"]::-webkit-outer-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
        input[type="number"] {
          -moz-appearance: textfield;
        }
        /* Added recently-added class for visual feedback */
        .product-card.recently-added {
          box-shadow: 0 0 10px rgba(0, 150, 255, 0.5);
          transition: box-shadow 0.3s ease;
        }
        .stepper-container.updating,
        .stepper-container-mobile.updating,
        .stepper-container-desktop.updating {
          opacity: 0.7;
          pointer-events: none;
        }
        .add-to-cart-btn.updating,
        .add-to-cart-btn-mobile.updating,
        .add-to-cart-btn-desktop.updating {
          opacity: 0.7;
          pointer-events: none;
        }
        .updating {
          opacity: 0.7;
          pointer-events: none;
        }
        /* Rest of your existing CSS styles remain the same */
        .product-card-mobile {
          background: var(--primary-bg);
          border: 1px solid var(--border-color);
          box-shadow: var(--card-shadow);
        }
        .card-style {
          margin: ${isMobile ? "0px 0px 0px 0px" : ""};
        }
        /* Base Styles */
        .page-content {
          overflow: auto;
          padding-bottom: 0px;
          background-color: var(--primary-bg);
          min-height: 100vh;
        }
        .main-content {
          padding: ${isMobile ? "0 10px" : "0 15px"};
          max-width: 100%;
          transition: opacity 0.3s ease;
        }
        /* Initial Loader */
        .initial-loader {
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 9999;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
        }
        .initial-loader p {
          color: var(--text-primary);
          font-size: 16px;
          margin: 0;
        }
        /* Skeleton Loader Styles */
        .skeleton-product-details {
          display: ${isMobile ? "block" : "flex"};
          gap: 10px;
          margin-bottom: 30px;
        }
        .skeleton-image {
          width: ${isMobile ? "100%" : "50%"};
          height: ${isMobile ? "300px" : "400px"};
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: skeleton-loading 1.5s infinite;
          border-radius: 8px;
        }
        .skeleton-content {
          flex: 1;
          padding: ${isMobile ? "10px 0" : "0 20px"};
        }
        .skeleton-title {
          height: 30px;
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: skeleton-loading 1.5s infinite;
          border-radius: 4px;
          margin-bottom: 15px;
          width: 80%;
        }
        .skeleton-price {
          height: 25px;
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: skeleton-loading 1.5s infinite;
          border-radius: 4px;
          margin-bottom: 20px;
          width: 60%;
        }
        .skeleton-buttons {
          display: flex;
          gap: 10px;
        }
        .skeleton-button {
          height: 40px;
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: skeleton-loading 1.5s infinite;
          border-radius: 20px;
          flex: 1;
        }
        .skeleton-grid {
          display: grid;
          grid-template-columns: repeat(${isMobile ? 2 : columnCount}, 1fr);
          gap: 10px;
          margin-top: 20px;
        }
        .skeleton-card {
          background: var(--primary-bg);
          border-radius: 8px;
          padding: 15px;
          border: 1px solid var(--border-color);
        }
        .skeleton-card-image {
          width: 100%;
          height: 200px;
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: skeleton-loading 1.5s infinite;
          border-radius: 8px;
          margin-bottom: 15px;
        }
        .skeleton-card-content {
          padding: 10px 0;
        }
        .skeleton-card-title {
          height: 20px;
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: skeleton-loading 1.5s infinite;
          border-radius: 4px;
          margin-bottom: 10px;
          width: 90%;
        }
        .skeleton-card-price {
          height: 18px;
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: skeleton-loading 1.5s infinite;
          border-radius: 4px;
          width: 70%;
        }
        @keyframes skeleton-loading {
          0% {
            background-position: 200% 0;
          }
          100% {
            background-position: -200% 0;
          }
        }
        /* Product Card Styles */
        .product-card {
          border-radius: 0px 0px 0px 0px;
          padding: ${isMobile ? "0px" : "5px"};
          box-shadow: var(--card-shadow);
          position: relative;
          break-inside: avoid;
        }
        .product-card-image {
          width: 100%;
          height: auto;
          object-fit: fill;
          border-radius: 8px;
          cursor: pointer;
        }
        .product-alert-badge {
         position: "absolute",
                                    top: "0px",
                                    right: "0px",
                                    background: "#DB4437", // Red alert background
                                    color: "#ffffff",
                                    padding: "0px 7px",
                                    borderRadius: "0px 0px 0px 10px",
                                    fontSize: "12px",
        }
        
        .product-card-cart-container {
          position: absolute;
          bottom: ${isMobile ? "27px" : "32px"};
          right: ${isMobile ? "5px" : "10px"};
        }
        .stepper-container {
          background: rgba(255, 255, 255, 0.9);
          padding: ${isMobile ? "3px" : "5px"};
          border-radius: 8px;
          display: flex;
          align-items: center;
          gap: 1px;
          width: ${isMobile ? "90px" : "100px"};
          height: ${isMobile ? "28px" : "30px"};
          border: 1px solid var(--accent-color);
        }
        .stepper-btn {
          padding: ${isMobile ? "6px" : "8px"};
          background: transparent;
          border: none;
          color: var(--accent-color);
          cursor: pointer;
        }
        .stepper-input {
          width: ${isMobile ? "28px" : "30px"};
          font-size: ${isMobile ? "12px" : "14px"};
          text-align: center;
          padding: 2px;
          color: var(--text-primary);
          background: transparent;
          border: none;
        }
        .add-to-cart-btn {
          background: var(--accent-color);
          color: white;
          border: none;
          border-radius: 10px;
          padding: ${isMobile ? "6px 10px" : "8px 12px"};
          font-size: ${isMobile ? "11px" : "12px"};
          font-weight: bold;
          cursor: pointer;
        }
        .add-to-cart-btn i {
          font-size: ${isMobile ? "20px" : "20px"};
        }
        .add-to-cart-btn-mobile {
          background: var(--accent-color);
          color: white;
          border: none;
          font-size: 14px;
          font-weight: bold;
          cursor: pointer;
          border-radius: 10px;
          padding: 10px 5px;
        }
        .add-to-cart-btn-mobile i {
          font-size: 12px;
          margin-right: 0px;
          padding: 0px 10px;
        }
        .product-card-title {
          font-size: ${isMobile ? "13px" : "14px"};
          margin: ${isMobile ? "0px 0 0" : "0px 0 0"};
          color: var(--text-primary);
          font-weight: 500;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .product-card-price {
          color: var(--text-primary);
          margin: ${isMobile ? "3px 0 0" : "5px 0 0"};
          font-size: ${isMobile ? "12px" : "14px"};
        }
        /* Mobile Product Styles */
        .mobile-product-container {
          margin-top: ${isMobile ? "70px" : "0px"};
        }
        .media-slider-container {
          position: relative;
          width: 100%;
          height: 35vh;
          max-height: 400px;
          margin-bottom: 10px;
        }
        .media-slider-image,
        .media-slider-video {
          width: 100%;
          height: 100%;
          object-fit: contain;
          border-radius: 8px;
          cursor: pointer;
        }
        .media-slider-youtube {
          position: relative;
          width: 100%;
          height: 100%;
          border-radius: 8px;
          overflow: hidden;
        }
        .youtube-iframe {
          width: 100%;
          height: 100%;
          border-radius: 8px;
        }
        .media-nav-btn {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 35px;
          height: 35px;
          font-size: 16px;
          padding: 0px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.8);
          display: flex;
          align-items: center;
          justify-content: center;
          border: none;
          cursor: pointer;
        }
        .media-prev-btn {
          left: 5px;
        }
        .media-next-btn {
          right: 5px;
        }
        .media-thumbnails-container {
          position: absolute;
          bottom: 5px;
          width: 100%;
          display: flex;
          justify-content: center;
          overflow-x: auto;
          padding: 5px 0;
          background: rgb(0 0 0 / 0%);
        }
        .media-thumbnail {
          width: 30px;
          height: 30px;
          margin: 0 3px;
          cursor: pointer;
          border: 1px solid #fff;
          border-radius: 3px;
        }
        .media-thumbnail.active {
          border: 2px solid var(--accent-color);
        }
        .media-thumbnail-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 3px;
        }
        .media-thumbnail-icon {
          width: 100%;
          height: 100%;
          background-color: #00000096;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .media-thumbnail-icon i {
          color: white;
          font-size: 12px;
        }
        .no-media-placeholder {
          margin-bottom: 10px;
          width: 100%;
          height: 35vh;
          border-radius: 8px;
          background-color: var(--primary-bg);
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid var(--border-color);
          color: var(--text-primary);
        }
        .product-actions {
          display: flex;
          gap: 10px;
        }
        .like-btn,
        .comment-btn {
          background: transparent;
          border: none;
          color: var(--text-secondary);
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 5px;
          font-size: 18px;
        }
        .like-btn.liked {
          color: var(--accent-color);
        }
        .product-alert {
          margin-left: auto;
          background-color: var(--accent-color);
          color: white;
          padding: 0px 10px;
          border-radius: 10px;
          font-size: 12px;
        }
        .product-info-mobile {
          padding: 0px 0px;
          display: ruby;
        }
        .product-title-mobile {
          color: var(--text-primary);
          font-size: 18px;
          width: 83%;
          margin-top: 15px;
          margin-bottom: 0px;
        }
        .price-cart-container-mobile {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 10px;
          margin-left: auto;
        }
        .product-price-mobile {
          font-size: 14px;
          margin: 0;
          color: var(--text-primary);
        }
        .original-price {
          font-weight: 300;
          text-decoration: line-through;
          color: #6c6c6c;
          margin-right: 8px;
        }
        .stepper-container-mobile {
          background: rgba(255, 255, 255, 0.9);
          padding: 3px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          gap: 1px;
          width: 90px;
          height: 28px;
          border: 1px solid var(--accent-color);
        }
        .stepper-input-mobile {
          width: 28px;
          font-size: 12px;
          text-align: center;
          padding: 2px;
          color: var(--text-primary);
          background: transparent;
          border: none;
        }
        .product-details-section {
          flex: 2;
          width: 100%;
          max-height: 600px;
          overflow-y: auto;
          padding: 0px 0px 0px 16px;
          border-left: 5px solid var(--accent-color);
          color: var(--text-primary);
        }
        .view-more-link {
          color: var(--accent-color);
          cursor: pointer;
          margin-top: 1px;
          margin-bottom: 0px;
        }
        /* Desktop Layout */
        .desktop-layout-container {
          display: flex;
          gap: 0px;
          width: 50%;
          align-items: flex-start;
          margin-bottom: 0px;
        }
        .left-desktop-section {
          width: 100%;
          flex-shrink: 0;
          padding-right: 5px;
        }
        .right-desktop-section {
          width: 100%;
          flex-shrink: 0;
          padding-left: 5px;
        }
        .product-card-desktop {
          background: var(--primary-bg);
          border: 1px solid var(--border-color) !important;
          box-shadow: var(--card-shadow);
          margin-bottom: 10px;
        }
        .media-slider-container-desktop {
          position: relative;
          width: 96%;
          margin-right: auto;
          margin-left: auto;
          height: ${isMobile ? "30vh" : "65vh"};
          max-height: 800px;
          margin-bottom: 10px;
        }
        .media-slider-image-desktop,
        .media-slider-video-desktop {
          width: 100%;
          height: 100%;
          object-fit: contain;
          border-radius: 8px;
          cursor: pointer;
        }
        .media-slider-youtube-desktop {
          position: relative;
          width: 100%;
          height: 100%;
          border-radius: 8px;
          overflow: hidden;
        }
        .youtube-iframe-desktop {
          width: 100%;
          height: 100%;
          border-radius: 8px;
        }
        .media-nav-btn-desktop {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 40px;
          font-size: 20px;
          padding: 0px 10px;
          border-radius: 25%;
          background: rgba(255, 255, 255, 0.8);
          border: none;
          cursor: pointer;
        }
        .media-prev-btn-desktop {
          left: 10px;
        }
        .media-next-btn-desktop {
          right: 10px;
        }
        .media-thumbnails-container-desktop {
          position: absolute;
          bottom: 10px;
          width: 100%;
          display: flex;
          justify-content: center;
          overflow-x: auto;
          padding: 10px 0;
          background: rgb(0 0 0 / 0%);
        }
        .media-thumbnail-desktop {
          width: 40px;
          height: 40px;
          margin: 0 5px;
          cursor: pointer;
          border: 1px solid #fff;
          border-radius: 5px;
        }
        .media-thumbnail-desktop.active {
          border: 2px solid var(--accent-color);
        }
        .media-thumbnail-image-desktop {
          width: 100%;
          height: 100%;
          object-fit: contain;
          border-radius: 5px;
        }
        .media-thumbnail-icon-desktop {
          width: 100%;
          height: 100%;
          background-color: #00000096;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .media-thumbnail-icon-desktop i {
          color: white;
          font-size: 16px;
        }
        .no-media-placeholder-desktop {
          margin-bottom: 10px;
          width: 100%;
          height: 70vh;
          border-radius: 8px;
          background-color: var(--primary-bg);
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid var(--border-color);
          color: var(--text-primary);
        }
        .fas {
          color: var(--text-secondary) !important;
        }
      
        .product-actions-desktop {
          display: flex;
          gap: 10px;
        }
        .like-btn-desktop,
        .comment-btn-desktop {
          background: transparent;
          border: none;
          color: var(--text-secondary);
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 5px;
          font-size: 18px;
        }
        .like-btn-desktop.liked {
          color: var(--accent-color);
        }
        .product-alert-desktop {
          margin-left: auto;
          background-color: var(--accent-color);
          color: white;
          padding: 0px 5px;
          border-radius: 10px;
          font-size: 12px;
        }
        .product-info-desktop {
          padding: 0px 0px;
          display: flex;
        }
        .product-title-desktop {
          color: var(--text-primary);
          font-size: 18px;
          width: 83%;
          margin-top: 12px;
        }
        .price-cart-container-desktop {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 10px;
          margin-left: auto;
        }
        .product-price-desktop {
          font-size: 16px;
          margin: 0;
          color: var(--text-primary);
        }
        .original-price-desktop {
          font-weight: 300;
          text-decoration: line-through;
          color: #6c6c6c;
          margin-right: 8px;
        }
        .stepper-container-desktop {
          background: rgba(255, 255, 255, 0.9);
          padding: 5px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          gap: 1px;
          width: 100px;
          height: 30px;
          border: 1px solid var(--accent-color);
        }
        .stepper-btn-desktop {
          padding: 8px;
          background: transparent;
          border: none;
          color: var(--accent-color);
          cursor: pointer;
        }
        .stepper-input-desktop {
          width: 30px;
          font-size: 14px;
          text-align: center;
          padding: 2px;
          color: var(--text-primary);
          background: transparent;
          border: none;
        }
        .add-to-cart-btn-desktop {
          background: var(--accent-color);
          color: white;
          border: none;
          font-size: 14px;
          font-weight: bold;
          cursor: pointer;
          border-radius: 10px;
          padding: 10px 5px;
        }
        .add-to-cart-btn-desktop i {
          font-size: 12px;
          margin-right: 0px;
          padding: 0px 10px;
        }
        .product-details-section-desktop {
          flex: 2;
          margin-top: 10px;
          max-height: 600px;
          overflow-y: auto;
          padding: 0px 0px 0px 16px;
          border-left: 5px solid var(--accent-color);
          color: var(--text-primary);
        }
        .view-more-link-desktop {
          color: var(--accent-color);
          cursor: pointer;
          margin-top: 0px;
          margin-bottom: 0px;
        }
        /* Products Grid Styles */
        .even-products-section {
          margin-top: 10px;
          margin-right: 10px;
        }
        .even-products-grid,
        .odd-products-grid {
          display: grid;
          gap: 10px;
          align-items: start;
        }
        .product-column {
          display: flex;
          flex-direction: column;
          gap: 0px;
        }
        .mobile-products-grid-container {
          width: 100%;
          margin-top: 20px;
        }
        .mobile-products-grid {
          display: grid;
          gap: 8px;
          align-items: start;
        }
        .product-column-mobile {
          display: flex;
          flex-direction: column;
          gap: 0px;
        }
        /* Media Modal Styles */
        .media-modal {
          display: block;
          background-color: rgba(0, 0, 0, 0.95);
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 1050;
        }
        .media-modal-dialog {
          width: 100%;
          height: 100%;
          margin: 0;
          max-width: 100%;
        }
        .media-modal-content {
          background: transparent;
          border: none;
          height: 100%;
          position: relative;
        }
        .media-modal-body {
          height: 100%;
          padding: 0;
        }
        .media-modal-transform-content {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }
        .media-modal-image {
          max-width: 100%;
          max-height: 90%;
          object-fit: contain;
        }
        .media-modal-video {
          max-width: 100%;
          max-height: 90%;
          object-fit: contain;
        }
        .media-modal-youtube {
          width: 100%;
          height: 90%;
          position: relative;
          padding-top: 56.25%;
        }
        .media-modal-youtube-iframe {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border-radius: 10px;
        }
        .rotate-btn {
          position: absolute;
          bottom: ${isMobile ? "75px" : "90px"};
          width: 40px;
          z-index: 1061;
        }
        .rotate-left {
          left: ${isMobile ? "37%" : "45%"};
        }
        .rotate-right {
          right: ${isMobile ? "37%" : "45%"};
        }
        .media-nav-btn-modal {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          z-index: 1061;
          width: 40px;
          font-size: ${isMobile ? "24px" : "30px"};
          padding: ${isMobile ? "0px 8px" : "0px 12px"};
          border-radius: 25%;
        }
        .media-prev-btn-modal {
          left: ${isMobile ? "5px" : "10px"};
        }
        .media-next-btn-modal {
          right: ${isMobile ? "5px" : "10px"};
        }
        .media-modal-thumbnails {
          position: absolute;
          bottom: 5px;
          width: 100%;
          display: flex;
          justify-content: center;
          overflow-x: auto;
          padding: 10px 0;
          background: rgba(0, 0, 0, 0.6);
        }
        .media-modal-thumbnail {
          position: relative;
          width: ${isMobile ? "50px" : "60px"};
          height: ${isMobile ? "50px" : "60px"};
          margin: ${isMobile ? "0 4px" : "0 5px"};
          cursor: pointer;
          border: 0.5px solid #fff;
          border-radius: 5px;
        }
        .media-modal-thumbnail.active {
          border: 2px solid var(--accent-color);
        }
        .media-modal-thumbnail-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 5px;
        }
        .media-modal-thumbnail-icon {
          width: 100%;
          height: 100%;
          background-color: #00000096;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .media-modal-thumbnail-icon i {
          color: white;
          font-size: 24px;
        }
        .media-modal-close-btn {
          position: absolute;
          top: 10px;
          right: ${isMobile ? "5px" : "10px"};
          z-index: 1061;
          background: var(--accent-color);
        }
        /* Comment Modal Styles */
        .comment-modal {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.8);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
        }
        .comment-modal-content {
          background: var(--primary-bg);
          padding: 20px;
          border-radius: 10px;
          width: 90%;
          max-width: 500px;
          max-height: 80vh;
          overflow-y: auto;
          position: relative;
          border: 1px solid var(--border-color);
        }
        .comment-modal-close {
          position: absolute;
          top: 10px;
          right: 10px;
          background: none;
          border: none;
          font-size: 1.5rem;
          cursor: pointer;
          color: var(--text-primary);
        }
        .comment-list {
          max-height: 50vh;
          overflow-y: auto;
        }
        .comment-item {
          display: flow-root;
          justify-content: space-between;
          padding: 10px 0;
          border-bottom: 1px solid var(--border-color);
        }
        .comment-text-cell {
          width: 93%;
          color: var(--text-primary);
        }
        .comment-action-cell {
          width: 7%;
        }
        .delete-comment-btn {
          background: var(--accent-color);
          color: white;
          border: none;
          padding: 7px 10px;
          border-radius: 5px;
          cursor: pointer;
          font-size: 0.8rem;
        }
        .comment-meta {
          display: block;
          float: right;
          color: var(--text-secondary);
          font-size: 10px !important;
          line-height: normal;
        }
        .comment-input-container {
          display: flex;
          gap: 10px;
          position: sticky;
          bottom: 0;
          background: var(--primary-bg);
          padding-top: 10px;
          border-top: 1px solid var(--border-color);
        }
        .comment-input {
          flex: 1;
          padding: 10px;
          border: 1px solid var(--border-color);
          border-radius: 20px;
          background: var(--primary-bg);
          color: var(--text-primary);
        }
        .comment-submit-btn {
          background: var(--accent-color);
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 20px;
          cursor: pointer;
        }
        /* Delete Confirmation Modal */
        .delete-confirm-modal {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.8);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
        }
        .delete-confirm-content {
          background: var(--primary-bg);
          padding: 20px;
          border-radius: 10px;
          width: 90%;
          max-width: 400px;
          text-align: center;
          border: 1px solid var(--border-color);
        }
        .delete-confirm-message {
          font-size: 1rem;
          margin-bottom: 20px;
          color: var(--text-primary);
        }
        .delete-confirm-buttons {
          display: flex;
          justify-content: center;
          gap: 10px;
        }
        .confirm-delete-btn {
          background: var(--accent-color);
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 5px;
          cursor: pointer;
        }
        .cancel-delete-btn {
          background: var(--border-color);
          color: var(--text-primary);
          border: none;
          padding: 10px 20px;
          border-radius: 5px;
          cursor: pointer;
        }
        /* Text Center */
        .text-center {
          text-align: center;
        }
        .text-center h5 {
          color: var(--text-primary);
        }
        /* Scaler Loader */
        .scaler-loader {
          display: inline-block;
          position: relative;
          width: 80px;
          height: 80px;
        }
        .scaler-loader-inner {
          position: absolute;
          top: 33px;
          width: 13px;
          height: 13px;
          border-radius: 50%;
          background: var(--accent-color);
          animation-timing-function: cubic-bezier(0, 1, 1, 0);
        }
        .scaler-loader-circle:nth-child(1) {
          left: 8px;
          animation: scaler-loader1 0.6s infinite;
        }
        .scaler-loader-circle:nth-child(2) {
          left: 8px;
          animation: scaler-loader2 0.6s infinite;
        }
        .scaler-loader-circle:nth-child(3) {
          left: 32px;
          animation: scaler-loader2 0.6s infinite;
        }
        .scaler-loader-circle:nth-child(4) {
          left: 56px;
          animation: scaler-loader3 0.6s infinite;
        }
        @keyframes scaler-loader1 {
          0% {
            transform: scale(0);
          }
          100% {
            transform: scale(1);
          }
        }
        @keyframes scaler-loader3 {
          0% {
            transform: scale(1);
          }
          100% {
            transform: scale(0);
          }
        }
        @keyframes scaler-loader2 {
          0% {
            transform: translate(0, 0);
          }
          100% {
            transform: translate(24px, 0);
          }
        }
          .redcolor{
          color: rgb(219, 68, 55) !important;
          }
           .white{
          color: rgb(255, 255, 255) !important;
          }
      `}</style>
    </>
  );
}

export default ProductDetail;
